import React from 'react'

const Profile = () => {
    return (
        <div className='board'>
        <div className='story_board'>
            <div className='imgg'><img className='tedd' src='./teddy1.png'></img></div>
            <div className='plus'>
           <div className='plus1'>whart's on your mind</div> 
           <div className='container'>
         <div className='bg'><i class="fa fa-file-video-o" aria-hidden="true"></i><span className='liveContent'>Live video</span>
             </div>
             <div className='bg'><i class="fa fa-picture-o" aria-hidden="true"></i><span className='liveContent'>Photo/Video</span></div>
            
             <div className='bg'><i class="fa fa-smile-o" aria-hidden="true"></i><span className='liveContent'>Feeling/Activity</span></div>
        </div></div></div> </div>
    )
}

export default Profile
